var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeclineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99967 0.833374C4.93706 0.833374 0.833008 4.93743 0.833008 10C0.833008 15.0626 4.93706 19.1667 9.99967 19.1667C15.0623 19.1667 19.1663 15.0626 19.1663 10C19.1663 4.93743 15.0623 0.833374 9.99967 0.833374ZM13.0889 6.91078C13.4144 7.23622 13.4144 7.76386 13.0889 8.0893L11.1782 10L13.0889 11.9108C13.4144 12.2362 13.4144 12.7639 13.0889 13.0893C12.7635 13.4147 12.2359 13.4147 11.9104 13.0893L9.99967 11.1786L8.08893 13.0893C7.76349 13.4147 7.23586 13.4147 6.91042 13.0893C6.58498 12.7639 6.58498 12.2362 6.91042 11.9108L8.82116 10L6.91042 8.0893C6.58498 7.76386 6.58498 7.23622 6.91042 6.91078C7.23586 6.58535 7.76349 6.58535 8.08893 6.91078L9.99967 8.82153L11.9104 6.91078C12.2359 6.58535 12.7635 6.58535 13.0889 6.91078Z",
    fill: "#E62E05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeclineIcon);
export default __webpack_public_path__ + "static/media/decline-icon.6d7a93f2e6519db6a018fe0678064603.svg";
export { ForwardRef as ReactComponent };